// extracted by mini-css-extract-plugin
export default {"container":"PageInPopup__container--3SP","error":"PageInPopup__error--3tg"};